import * as Yup from "yup";

export const customTagsFormValidation = Yup.object().shape({
  name: Yup.string().nullable().required("Name is required!"),
  mobile_number: Yup.string().nullable(),
});
